<template>
  <transition name="fade">
    <div
      class="sort_type_dialog"
      :class="{ 'android': android }"
      v-if="showSortDialog"
      @click="closeDialog"
    >
      <ul>
        <li
          v-for="item in textArr"
          :key="item.id"
          :class="{'active': item.text === currentText}"
          @click.stop="changeSortType(item)"
        >{{item.text}}</li>
      </ul>
    </div>
  </transition>
</template>

<script>
export default {
    components: {},
    props: {
        textArr: {
            type: Array,
            required: true
        },
        showSortDialog: {
            type: Boolean,
            required: false
        },
        text: {
            type: String,
            default: "最近更新"
        }
    },
    watch: {
        text(val, old) {
            this.currentText = val
        }
    },
    computed: {
        android() {
            return window.system === "android"
        }
    },
    data() {
        return {
            currentText: "最近更新",
            sortTypes: []
        }
    },
    mounted() {},

    methods: {
        changeSortType(item) {
            // 选择了排序方式后，关闭遮罩层，并且通知父组件更新数据顺序
            this.currentText = item.text
            this.$emit("changeSortType", item.text)
            this.$emit("update:showSortDialog", false)
        },
        closeDialog() {
            this.$emit("update:showSortDialog", false)
        }
    }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
}
.sort_type_dialog {
    &.android {
        top: 5.05rem !important;
    }
    position: fixed;
    z-index: 100;
    top: 4.95rem;
    top: calc(constant(safe-area-inset-top) + 3.95rem);
    top: calc(env(safe-area-inset-top) + 3.95rem);
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    ul {
        width: 100%;
        height: 3.9rem;
        background: #fff;
        li {
            margin: 0 0.5rem;
            border-bottom: 1px solid #f0f0f0;
            height: 1.95rem;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 0.7rem;
            font-weight: 400;
            color: rgba(122, 122, 122, 1);
            &:last-child {
                border-bottom: none;
            }
            &.active {
                color: #006cff;
            }
        }
    }
}
</style>
